// extracted by mini-css-extract-plugin
export default {"transfer-badge":"transfer-badge_transfer-badge__R+Wm2"};